import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { BookmarkedRoute } from '../types/ferry';
import { BaseRouteCard } from './BaseRouteCard';

interface SortableItemProps {
  id: string;
  bookmark: BookmarkedRoute;
  onRemove: () => void;
  language: string;
  t: any;
}

export const SortableItem: React.FC<SortableItemProps> = ({
  id,
  bookmark,
  onRemove,
  language,
  t
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      <BaseRouteCard
        routeResult={bookmark.routeResult}
        selectedDate={bookmark.selectedDate}
        language={language}
        t={t}
        showDragHandle={true}
        dragHandleProps={listeners}
        bookmarkedAt={bookmark.bookmarkedAt}
        className=""
        actionButton={
          <button
            onClick={(e) => { 
              e.preventDefault();
              e.stopPropagation(); 
              onRemove(); 
            }}
            onMouseDown={(e) => { 
              e.preventDefault();
              e.stopPropagation(); 
            }}
            className="p-2 text-gray-400 hover:text-red-600 transition-all duration-200 hover:scale-110 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
            title="Remove"
            style={{ touchAction: 'none' }}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        }
      />
    </div>
  );
};